import type { Transition, TargetAndTransition } from "framer-motion";

/**
 * Shared framer-motion values for the app's mobile bottom-sheet modals
 * (guestlist pattern: overlay `items-end sm:items-center`, panel slides up
 * from y:100 and docks flush to the bottom on phones, centered on sm+).
 * Reference implementation: PGuestDetails.tsx. Use these constants instead
 * of re-typing the spring numbers in every converted modal.
 */
export const SHEET_INITIAL: TargetAndTransition = { opacity: 0, y: 100 };
export const SHEET_ANIMATE: TargetAndTransition = { opacity: 1, y: 0 };
export const SHEET_EXIT: TargetAndTransition = { opacity: 0, y: 100 };
export const SHEET_SPRING: Transition = {
  type: "spring",
  damping: 25,
  stiffness: 300,
};
